(ns machtfit.startpage.location
  "The products location and what changing it has to re-ask for.

  Separate from `machtfit.startpage.filterbar` so the handler can be tested:
  that namespace reaches `machtfit.startpage.events`, which registers
  `js/window` listeners when it loads and so cannot load under the test runner."
  (:require [machtfit.app.tracking :as tracking]
            [machtfit.repository.products :as products]
            [machtfit.repository.search-facets :as search-facets]
            [machtfit.startpage.search :as search]
            [machtfit.storage :as storage]))

(defn locations-equal? [location-1 location-2]
  (= (:coordinates location-1)
     (:coordinates location-2)))

(defn set-products-location-fx
  [db location]
  (let [location-changed? (not (locations-equal? location
                                                 (:products-location db)))
        home-location (get-in db [:user :home-location])
        work-location (get-in db [:user :place-of-business-location])]
    (if location-changed?
      (let [next-db (-> db
                        (assoc :products-location location)
                        (assoc-in [:ui :products-location-lookup-running?] false))]
        {:db next-db
         ::tracking/capture-event [db "location_set"
                                   (-> (:address location)
                                       (select-keys [:city :postcode])
                                       (assoc :equals-home (locations-equal? location home-location)
                                              :equals-work (locations-equal? location work-location)))]
         ;; The catalogue refetches through its own reaction; the server-only
         ;; path has no such reaction, so its search and facets are re-asked
         ;; for the new origin here. The facets carry the search with them
         ;; because they decide which of a preset's categories survive, and
         ;; they land a round trip after the request below is built.
         :fx (cond-> [[:dispatch [::products/reset]]]
               (search/server-only? next-db)
               (into [[:dispatch [::search/fetch]]
                      [:dispatch [::search-facets/fetch [::search/fetch]]]]))
         ::storage/local-storage-put {'machtfit.app.startpage.products-location location}})
      {:db db})))
